import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import Form from "react-validation/build/form";

import { ValidationProvider } from "../../validation/validation-provider";

import { BACKEND_CONFIG, LOGIN_URL } from "../../config/consts";
import Input from "../../components/Input";
import PasswordInput from "../../components/PasswordInput";
import { required, email } from "../../validation/validation";
import houses from "../../images/home-houses.svg";

import Agencies from "./Agencies";

import "../../styles/login-page.scss";

class LoginPage extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      password: "",
      agencies: null,
      token: "",
      refresh: "",
      loggedIn: false,
      redirectUrl: "",
    };

    this.formRef = React.createRef();
  }

  renderRedirect = () => {
    if (this.state.loggedIn) {
      return <Redirect to={this.state.redirectUrl} />;
    }
  };

  updateData = (e) => {
    const field = e.target.name;

    this.setState({ [field]: e.target.value });
  };

  render() {
    const { agencies, token, refresh } = this.state;

    return (
      <div className="component">
        {this.renderRedirect()}
        {agencies && token ? (
          <Agencies
            agencies={agencies}
            authenticate={() => {
              BACKEND_CONFIG.set("auth", token);
              BACKEND_CONFIG.set("refresh", refresh);
            }}
          />
        ) : (
          <div className="login-page">
            <img alt="home" className="houses-logo center image" src={houses} />
            <h1 className="login" data-testid="login-page-heading-label">
              Your small commercial quote starts here.
            </h1>
            <div
              className="container"
              style={{ width: "420px", borderRadius: "4px" }}
            >
              <div className="row">
                <div className="float-right login-registered">
                  <div className="center-box">
                    <Form ref={this.formRef}>
                      <div className="form-group label-static w-100">
                        <label htmlFor="emailAddress">Email Address</label>
                        <Input
                          style={{ height: "44px", width: "320px" }}
                          value={this.state.email}
                          type="email"
                          id="emailAddress"
                          name="email"
                          onChange={this.updateData}
                          field="emailAddress"
                          validations={[required, email]}
                          autoComplete="off"
                          data-testid="login-page-email-input"
                        />
                      </div>
                      <div className="form-group label-static w-100">
                        <label id="passwordLabel" htmlFor="password">
                          Password
                        </label>
                        <PasswordInput
                          style={{
                            paddingRight: "42px",
                            height: "44px",
                            width: "320px",
                          }}
                          value={this.state.password}
                          type="password"
                          id="password"
                          name="password"
                          onChange={this.updateData}
                          validations={[required]}
                          field="password"
                          autoComplete="off"
                          data-testid="login-page-password-input"
                        />
                      </div>
                      {this.state.generalValidationMessage && (
                        <div className="form-group label-static w-100">
                          <span className="error-message is-visible">
                            {this.state.generalValidationMessage}
                          </span>
                        </div>
                      )}
                    </Form>
                    <div className="forgot-password-link">
                      <Link to={"/reset-password"}>Forgot Password?</Link>
                    </div>
                    <button
                      className="btn btn-primary w-100"
                      id="LogIn"
                      data-testid="login-page-login-button"
                      onClick={() => {
                        this.login();
                      }}
                    >
                      Log In
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  login() {
    let isValid = ValidationProvider.isValid(this.formRef);

    if (!isValid) {
      this.setState({ isPaymentMethodValid: false });

      return;
    }

    var loginRequestUrl = `${BACKEND_CONFIG.apiUrl}${LOGIN_URL}`;

    axios
      .post(loginRequestUrl, {
        EmailAddress: this.state.email,
        Password: this.state.password,
      })
      .then((response) => {
        if (response.data.Agencies) {
          this.setState({
            agencies: response.data.Agencies,
            token: response.data.Token,
            refresh: response.data.RefreshToken,
          });
        }

        if (response.data.Agency) {
          BACKEND_CONFIG.set("auth", response.data.Token);
          BACKEND_CONFIG.set("refresh", response.data.RefreshToken);
          BACKEND_CONFIG.set("agencyid", response.data.Agency.AgencyId);

          this.setState({
            loggedIn: true,
            redirectUrl: "/home",
          });
        }
      })
      .catch((error) => {
        let errorResponse = error.response;

        if (errorResponse.data && errorResponse.data.Message) {
          this.setState({
            generalValidationMessage: errorResponse.data.Message,
          });
        } else {
          this.setState({
            generalValidationMessage: "Something went wrong. Please try again.",
          });
        }

        this.props.onServerValidationErrors(
          error.response.data.ValidationErrors
        );
      });
  }
}

export default LoginPage;
